/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/consistent-type-assertions */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, Inject, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HotToastService } from '@ngneat/hot-toast';
import { lineItemType, ProductObjectType, productTypesArray } from '../../core/constants/constants';
import { DataCollectorService } from '../../core/services/data_collector_services/data_collector_service.service';
import { LineItemService } from '../../core/services/lineitem/lineitem.service';
import { LocalisationService } from '../../core/services/localisation/zuper.localisation.service';
import { UtilityService } from '../../core/services/utility_functions/utility_functions.service';
import { Observable, ReplaySubject, Subscription, of } from 'rxjs';
import { BadgeOptions } from '../badge/badge.interface';
import { ZuperPopupService } from '../zuper-popup/zuper-popup.service';
import { AvailabilityTypes, GroupLineItemModel, LineItemModel, LineItemPickerColumns, LineItemPickerColumnType, LineItemPickerOptions } from './line-item-picker.interface';
import { LineItemPickerService } from './line-item-picker.service';
import { AbstractControl, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import _ from 'lodash';
import { MyCustomPaginatorIntl } from '../../core/services/paginator_service/my-paginator.service';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { debounceTime, distinctUntilChanged, switchMap, map, catchError, tap  } from 'rxjs/operators';
import { MarkupEventAnalyticsService } from 'app/core/services/analytics/markup-event-analytics.service';
import { ActivatedRoute } from '@angular/router';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import { MetaData } from 'ng-event-bus/lib/meta-data';

@Component({
  selector: 'line-item-picker',
  templateUrl: './line-item-picker.component.html',
  styleUrls: ['./line-item-picker.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [{ provide: MatPaginatorIntl, useClass: MyCustomPaginatorIntl }]
})
export class LineItemPickerComponent implements OnInit, OnDestroy {
  @Input() options: LineItemPickerOptions;

  selectedProducts: any[] = [];
  loaded: boolean = false;
  lineItemApiUrls: any;
  searchKey: string = '';
  selectedProductType: string;
  selectedLocation: any;
  selectedCategory: any;
  pagination: any = {
    totalRecords: 0,
    pageIndex: 1,
    pageSize: 5
  };
  showSelectedItems: boolean = false;
  companyCurrency: string;
  companyConfig: any;
  addOutOfStockProduct: boolean = true;
  addNegativeStockBalance: boolean = true;
  //Group Item
  selectedGroupProducts: any[] = [];
  groupSearchKey: string = '';
  groupPagination: any = {
    totalRecords: 0,
    pageIndex: 1,
    pageSize: 5
  };
  isAddItemLoading: boolean = false;
  tabs: any[] = [{
    displayName: 'Item',
    displayKey: 'text.item',
    dataKey: 'SingleItem',
    rel: 'single_item'
  }, {
    displayName: 'Group',
    displayKey: 'group',
    dataKey: 'ItemGroup',
    rel: 'item_group'
  }];
  defaultProductTypes: lineItemType[] = ['PRODUCT','PARTS','SERVICE'];
  productTypes: ProductObjectType[];
  availabilityTypes: any[] = AvailabilityTypes;
  viewMode: string = 'SingleItem';
  products: any[] = [];
  originalDataProducts: any[] = [];
  categories: any[] = [];
  groups: any[] = [];
  originalDataGroups: any[] = [];
  displayedColumns: string[] = ['SELECTION'];
  groupDisplayedColumns: string[] = ['SELECTION', 'GROUP_NAME', 'STATUS', 'TOTAL_ITEMS'];
  selectProductObj: any = {};
  masterGroupItems: any = {};
  restrictedColumns = ['PRICE', 'PURCHASE_PRICE', 'MARKUP'];
  disableProductControl = ['purchase_price', 'markup_value', 'price', 'quantity', 'location','serialNumber'];
  currencyDecimal: number = this.utilityService.getCurrencyDecimal();
  stepValue = this.utilityService.stepValue;
  markupSubList = {};
  purchasePriceSubList = {};
  selectedProductFormControl: any = {};
  filterLocationUid: string;
  getCategoryAsObject: boolean = false;
  isPricelistPresent: boolean = false;
  currentUser: any;
  markupType: string = 'FLAT';

  // Location
  locations: Observable<any[]>;
  locationSearchPagination = { currentPage: 1, totalPage: 1, keyword: '', isLoading: false };
  locationValueSubject: ReplaySubject<string | null> = new ReplaySubject<string | null>();
  allProductLocationSelectOption = { 'location_uid': 'ALL', 'location_name': 'None' };
  productLocationPickerList: any[] = [this.allProductLocationSelectOption];
  selectedLocationValue: string = null;
  allLocations: any[] = [];
  defaultPreferredLocationUid: string = null;

  //permission
  isEditSellingPriceDisabled: boolean = false;
  showPrice: boolean = false;

  private productParamObj: any = {
    'count': 5,
    'filter.keyword': '',
    'filter.location': '',
    'filter.product_category': '',
    'filter.product_type': '',
    'page': 1
  };
  private categoryParamObj: any = {
    'count': 200,
    'page': 1
  };
  private locationParamObj: any = {
    'count': 500,
    'page': 1
  };
  private groupParamObj: any = {
    'count': 5,
    'filter.keyword': '',
    'page': 1,
    'sort': 'ASC',
    'sort_by': 'created_at'
  };

  private groupAddingObj: any = {};
  private formattedGroupItems: any[] = [];
  private lineItemSubscription: Subscription;
  private lineItemFormGroup: UntypedFormGroup;
  private filterValues: any = {};
  currentPage: any;
  patchFiltersFromSDKSub$: Subscription;
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private localisationService: LocalisationService,
    private utilityService: UtilityService,
    private toast: HotToastService,
    private dataCollectorService: DataCollectorService,
    private lineItemService: LineItemService,
    private lineItemPickerService: LineItemPickerService,
    private zuperPopupService: ZuperPopupService,
    private markupEventAnalyticsService: MarkupEventAnalyticsService,
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private localStorageService: LocalStorageService,
  ) {
    this.lineItemFormGroup = this.formBuilder.group({
      tableRows: this.formBuilder.array([])
    });
  }

  ngOnInit(): void {
    this.localisationService.setDefaultLanguage();
    this.currentUser = this.localStorageService.getLocalStorage('user');
    this.companyCurrency = this.utilityService.companyCurrency;
    this.companyConfig = this.utilityService.companyConfig;
    this.addOutOfStockProduct = this.companyConfig?.product?.add_out_of_stock_product ?? this.addOutOfStockProduct;
    this.addNegativeStockBalance = this.companyConfig?.product?.add_negative_stock_balance ?? this.addNegativeStockBalance;
    this.markupType = this.companyConfig?.product?.default_markup_type ?? 'FLAT';
    this.showPrice = this.utilityService.hasPermission('product.show_selling_price') ?? false;
    this.isEditSellingPriceDisabled = !this.utilityService.hasPermission('product.edit_selling_price');
    this.lineItemApiUrls = this.lineItemService.lineItemAPIUrls;
    this.options = this.data?.data?.options ?? this.options;
    if(this.options.remoteData?.params?.pricelist){
      this.isPricelistPresent = true;
    }

    this.lineItemSubscription = this.lineItemPickerService.selectedLineItems.subscribe((data: any) => {
      const selectedItems: any[] = data?.length ? _.cloneDeep(data) : [];
      this.selectedProducts = selectedItems;
      this.selectedProducts.forEach((element: any) => {
        this.selectProductObj[element?.product_uid] = element;
      });
      if (this.options?.addFromProductGroup) {
        this.validateGroupItems(selectedItems);
      }
    });
    if (this.options?.addFromProductGroup) {
      this.viewMode = 'ItemGroup';
      this.getProductGroupData();
    } else {
      this.viewMode = 'SingleItem';
      this.updateDisplayedColumns();

      const defaultLocationUid = this.currentUser?.meta_data?.default_product_location;
      const isLocationFilterEnabled = this.options?.filters?.location?.enabled;
      if(defaultLocationUid && isLocationFilterEnabled){
        this.defaultPreferredLocationUid = defaultLocationUid;
        this.getLocationDetails();
      }else{
        this.getLineItemData();
      };
    }
    if(this.options?.getCategoryAsObject){
      this.getCategoryAsObject = this.options?.getCategoryAsObject ?? false;
    }
    this.initializeSDKHandlers();
  }

  updateDisplayedColumns(): void {
    if (this.options?.columns) {
      this.displayedColumns = this.displayedColumns.concat(this.options.columns?.map(column => column.type));
      if (this.showPrice === false) {
        this.displayedColumns = this.displayedColumns.filter(value => this.restrictedColumns.includes(value) === false);
      }else if(this.showPrice && (this.companyConfig?.product?.enable_markup === false)){
        this.displayedColumns = this.displayedColumns.filter(value => ['MARKUP'].includes(value) === false);
      }
    }
  }

  changeViewMode(mode: string): void {
    if (this.viewMode !== mode) {
      this.showSelectedItems = false;
    }
    this.viewMode = mode;
  }

  updateProducts(products: any): void {
    this.products = _.cloneDeep(products);
    this.products.forEach((product: any) => {
      if (!product.markup) {
        product.markup = { markup_type: this.markupType };
      }
      product.markup.markup_type = product?.markup?.markup_type ?? this.markupType;
  });
    if(this.filterLocationUid){
      this.products.forEach((product)=> {
        product['overall_quantity'] =  product?.overall_quantity ?? product?.quantity ?? 0;
      });
    }
    this.createTableFormControls(this.products);
  }

  createTableFormControls(products: any): void {
    this.updateBasicRequiredProductValues(products);
    this.lineItemFormGroup.setControl('tableRows', this.formBuilder.array([]));
    const control: UntypedFormArray = this.lineItemFormGroup?.get('tableRows') as UntypedFormArray;
    const requiredColumns: any[] = this.options.columns?.filter(column => column?.isEditable);
    if (requiredColumns?.length) {
      products.forEach((product: any, index: number) => {
        const formGroup: UntypedFormGroup = this.formBuilder.group({});
        let selectedProduct;
        if(this.options?.module === 'JOB'){
          selectedProduct = this.selectedProducts.find(value => value?.line_item_uid ? value?.line_item_uid === product?.line_item_uid : value.product_uid === product.product_uid);
        }else{
          selectedProduct = this.selectedProducts.find(value => value.product_uid === product.product_uid);
        }
        formGroup.addControl('lineItem', new UntypedFormControl(product?.line_item_uid ?? product.product_uid ?? product.product_id ));
        requiredColumns.forEach((columnInfo: LineItemPickerColumns) => {
          if (columnInfo.type === 'BRAND') {
            formGroup.addControl('brand', new UntypedFormControl({ value: product.brand, disabled: false }, columnInfo.isRequired ? Validators.required : null));
          }
          if (columnInfo.type === 'SPECIFICATION') {
            formGroup.addControl('specification', new UntypedFormControl({ value: product.specification, disabled: false }, columnInfo.isRequired ? Validators.required : null));
          }
          if (columnInfo.type === 'LOCATION') {
            let locationUid = '';
            if(selectedProduct?.location_uid){
              locationUid = selectedProduct?.location_uid;
            }else if(product?.location_uid){
              const locationObject = product?.location_availability.find(locationItem => locationItem?.location?.location_uid === product?.location_uid);
              locationUid = locationObject?.location?.location_uid;
            }else if(this.defaultPreferredLocationUid && product?.location_availability?.some(locationItem => locationItem?.location?.location_uid === this.defaultPreferredLocationUid)){
              locationUid = this.defaultPreferredLocationUid;
            }else if(product?.location_availability?.length > 1){
              const locationObject = product?.location_availability.find(locationItem => locationItem.quantity > 0);
              locationUid = locationObject?.location?.location_uid;
            }else if(product?.location_availability?.length === 1){
              const locationObject = product?.location_availability[0];
              locationUid = locationObject?.location?.location_uid;
            }
            const location: any = {
              value: locationUid ? locationUid : '',
              disabled: !selectedProduct || this.filterLocationUid
            };
            formGroup.addControl('location', new UntypedFormControl(location, columnInfo.isRequired ? Validators.required : null));
          }
          if (columnInfo.type === 'PRICE') {
            const priceValue: number = selectedProduct ? (selectedProduct.price ?? selectedProduct.unit_price) : (product.price ?? product.unit_price);
            const isMarkup = this.isColumnAvailable(this.options.columns, LineItemPickerColumnType.MARKUP);
            const priceFormState: any = {
              value: priceValue ?? null,
              disabled: this.isEditSellingPriceDisabled || !selectedProduct || (isMarkup && selectedProduct.markup?.['markup_value'])
            };
            formGroup.addControl('price', new UntypedFormControl(priceFormState, columnInfo.isRequired && this.showPrice ? Validators.required : null));
          }
          if (columnInfo.type === 'QUANTITY') {
            const quantityFormState: any = {
              value: selectedProduct ? selectedProduct.quantity : '',
              disabled: !selectedProduct
            };
            const validators = [this.utilityService.numberMinValueValidator];
            if (columnInfo.isRequired) {
              validators.push(Validators.required);
            }
            if((this.options?.data?.length > 0 || (this.products?.length && this.filterLocationUid)) && this.options?.showMaxQuantityError){
              if(selectedProduct?.available_quantity && ['ESTIMATES','INVOICE','JOB'].includes(this.options?.module)){
                validators.push(Validators.max(selectedProduct.available_quantity));
              }else if(selectedProduct?.quantity){
                validators.push(Validators.max(selectedProduct.quantity));
              }
            }
            validators.push(this.greaterThanZeroValidator(0));
            const productToBeChecked = selectedProduct ? selectedProduct : product;
            if(this.allowToAddOutOfStockProduct(productToBeChecked, index)){
              validators.push(this.ValidateQuantity());
              // disable the unselected product which is out of stock
              if(this.utilityService.isEmptyOrUndefined(selectedProduct)){
                formGroup.disable();
              }
            }
            formGroup.addControl('quantity', new UntypedFormControl(quantityFormState, validators));
          }
          if (columnInfo.type === 'SERIAL_NO') {
            const serialNumberValue: any = selectedProduct ? (columnInfo.multiple ? selectedProduct.serial_nos : (selectedProduct.serial_nos?.[0] ?? [])) : null;
            const serialNumberFormState: any = {
              value: serialNumberValue,
              disabled:!selectedProduct
            };
            formGroup.addControl('serialNumber', new UntypedFormControl(serialNumberFormState, columnInfo.isRequired ? Validators.required : null));
          }
          if(columnInfo.type === 'PURCHASE_PRICE'){
            const validators = [];
            const purchasePriceFormState = {
              value: null,
              disabled: this.isEditSellingPriceDisabled || !selectedProduct
            };
            if(!this.utilityService.isEmptyOrUndefined(selectedProduct?.purchase_price)){
              purchasePriceFormState.value = selectedProduct.purchase_price;
            }else if(!this.utilityService.isEmptyOrUndefined(product?.purchase_price)){
              purchasePriceFormState.value = product.purchase_price;
            }
            if(columnInfo?.isRequired){
              validators.push(Validators.required);
            }
            validators.push(this.greaterThanZeroValidator(0, true));
            formGroup.addControl('purchase_price', new UntypedFormControl(purchasePriceFormState, validators));
          }
          if(columnInfo.type === 'MARKUP'){
            const markupValueFormState = {
              value: null,
              disabled:!selectedProduct
            };
            if(!this.utilityService.isEmptyOrUndefined(selectedProduct?.markup?.markup_value)){
              markupValueFormState.value = selectedProduct?.markup?.markup_value;
            }else if(!this.utilityService.isEmptyOrUndefined(product?.markup?.markup_value)){
              markupValueFormState.value = product?.markup?.markup_value;
            }
            formGroup.addControl('markup_value', new UntypedFormControl(markupValueFormState, columnInfo.isRequired ? Validators.required : null));
          }
        });
        const serialNumber: AbstractControl = formGroup.get('serialNumber');
        if (serialNumber) {
          const serialNoColumn: LineItemPickerColumns = requiredColumns.find(column => column.type === LineItemPickerColumnType.SERIAL_NO);
          serialNumber.addValidators(this.validateSerialNumberCount(index,serialNoColumn?.multiple ?? false,serialNumber));
        }
        control.setControl(index, formGroup);
        this.handleInputSubscription(product, index);
      });
      if (this.filterLocationUid) {
        this.setProductLocation();
      }
    }
    this.lineItemFormGroup?.get('tableRows')?.valueChanges?.pipe(debounceTime(500),distinctUntilChanged()).subscribe((data: any) => {
      this.updateSelectedProductValues(data);
    });
    this.selectedProducts.forEach((product: any)=>{
      this.updateSelectedProductControls(product);
    });
  }

  updateSelectedProductControls(product): void{
    const rowIndex: number = this.products.findIndex(productValue => product.product_uid === productValue.product_uid);
    if(!this.selectedProductFormControl[product?.product_uid]){
      this.updateSelectedProductFormControls(rowIndex, product?.product_uid, 'ADD');
    }else{
      this.updateSelectedProductFormControls(rowIndex, product?.product_uid, 'UPDATE');
    }
  }

  updateSelectedProductValues(data: any[]): void {
    data?.forEach((productValue: any, index: number) => {
      if (!this.utilityService.isEmptyOrUndefined(productValue?.quantity)) {
        this.setErrorsSerialNumberControl(productValue?.quantity, index);
      }
      this.selectedProducts.forEach((product: any) => {
        if (productValue.lineItem === (product.line_item_uid ?? product?.product_uid ?? product.product_id)) {
          if(!this.utilityService.isEmptyOrUndefined(productValue?.purchase_price)){
            const convertedPurchasePrice: number = Number(productValue.purchase_price);
            product['purchase_price'] = convertedPurchasePrice;
          }
          if(!this.utilityService.isEmptyOrUndefined(productValue?.markup) && productValue.markup?.markup_value){
            const convertedMarkupValue: number = Number(productValue?.markup?.markup_value);
            product['markup_value'] = convertedMarkupValue;
          }
          if (!this.utilityService.isEmptyOrUndefined(productValue?.price)) {
            const convertedPrice: number = Number(productValue.price);
            product['price'] = convertedPrice;
            product['unit_price'] = convertedPrice;
          }
          if (!this.utilityService.isEmptyOrUndefined(productValue?.quantity)) {
            const convertedQuantity: number = Number(productValue.quantity);
            product['quantity'] = convertedQuantity;
          }
          if (productValue.serialNumber) {
            product['serial_nos'] = typeof productValue.serialNumber === 'string' ? [productValue.serialNumber] : productValue.serialNumber?.map((value: any) => value?.label ? value.label : value);
          }
          product['location_uid'] = !this.utilityService.isEmptyOrUndefined(productValue?.location) ? productValue.location : product['location_uid'];
          product['specification'] = !this.utilityService.isEmptyOrUndefined(productValue?.specification) ? productValue.specification : product['specification'];
          product['brand'] = !this.utilityService.isEmptyOrUndefined(productValue?.brand) ? productValue.brand : product['brand'];
        }
      });
    });
  }

  updateBasicRequiredProductValues(products: any[]): void {
    products.forEach((product: any) => {
      product['available_quantity'] = !this.utilityService.isEmptyOrUndefined(product['available_quantity']) ? product['available_quantity'] : product?.quantity;
      if (!product?.location_availability?.length && (product?.product?.location_availability || product?.product_ref_id?.location_availability)) {
        product.location_availability = product?.product?.location_availability ?? product?.product_ref_id?.location_availability ?? [];
      }
    });
  }

  getLineItemData(preferredLocationDetails?): void {  
    //commmon method to get category and location
    const getCategoryAndLocation = (locationDetails?) => {
      if (this.options?.filters?.category?.enabled) {
        this.getProductCategoryData();
      }
      if(this.options?.filters?.location?.enabled){
        this.locations = this.getProductLocationData(true, locationDetails);
      }
    };
    this.setProductTypeFilter();

    if (this.options?.data) {
      this.originalDataProducts = this.options.data;
      this.updateProducts(this.options.data);
      getCategoryAndLocation();
      return;
    };
    
    const productUrl: string = this.options.remoteData?.dataUrl || this.lineItemApiUrls.productUrl;
    if (this.options.remoteData?.dataUrl && this.options.remoteData?.params) {
      this.productParamObj = { ...this.productParamObj, ...this.options.remoteData.params, 'filter.is_deleted': false };
    }
    this.filterLocationUid = this.options?.remoteData?.params?.['filter.location'] ?? this.defaultPreferredLocationUid;
    this.productParamObj.page = this.pagination.pageIndex;
    this.loaded = false;
    this.dataCollectorService.getData(productUrl, this.productParamObj).subscribe({
      next:(response: any) => {
        this.loaded = true;
        this.updateProducts(response.data);
        this.originalDataProducts = response.data;
        this.pagination.totalRecords = response.total_records;
        getCategoryAndLocation(preferredLocationDetails);
      },
      error:() => {
        this.loaded = true;
        getCategoryAndLocation(preferredLocationDetails);
      }
    });
  }

  getProductCategoryData(): void {
    this.loaded = false;
    this.dataCollectorService.getData(this.lineItemApiUrls.productCategoryUrl, this.categoryParamObj).subscribe((categories: any) => {
      this.loaded = true;
      this.categories = categories.data;
    }, (_error: any) => {
      this.loaded = true;
    });
  }

  setProductTypeFilter(): void {
    // Check if the product types are provided in options, otherwise use defaultProductTypes
    const selectedProductTypes = this.options?.filters?.productType?.types ? this.options.filters.productType.types : this.defaultProductTypes;
    this.productTypes = productTypesArray.filter(product => selectedProductTypes.includes(product.value));
    this.productParamObj['filter.product_type'] = this.productTypes.map(product => product.value).join(',');
  }

  getProductGroupData(): void {
    this.loaded = false;
    this.dataCollectorService.getData(this.lineItemApiUrls.productGroupUrl, this.groupParamObj).subscribe((groups: any) => {
      this.loaded = true;
      this.groups = groups.data;
      this.originalDataGroups = groups.data;
      this.groupPagination.totalRecords = groups.total_records;
    }, (_error: any) => {
      this.loaded = true;
    });
  }

  getProductData(): void {
    this.loaded = false;
    this.productParamObj.page = this.pagination.pageIndex;
    this.dataCollectorService.getData(this.lineItemApiUrls.productUrl, this.productParamObj).subscribe((response: any) => {
      this.loaded = true;
      this.updateProducts(response.data);
      this.originalDataProducts = response.data;
      this.pagination.totalRecords = response.total_records;
      if (this.filterLocationUid) {
        this.setProductLocation();
      }
    }, (_error: any) => {
      this.loaded = true;
    });
  }

  setProductLocation(): void {
    const changedLocation: string = this.productParamObj?.['filter.location'] ?? '';
    const rowControls: UntypedFormGroup[] = this.lineItemFormGroup?.get('tableRows')?.['controls'];
    rowControls.forEach((group: UntypedFormGroup, index: number) => {
      const isSelectedRow: boolean = this.products?.[index] && this.isSelectedProduct(this.products?.[index]);
      if (!isSelectedRow && group?.controls?.location) {
        group?.controls?.location.setValue(changedLocation);
      }
    });
  }

  getProductLocation(product: any): any {
    const rowIndex: number = this.products.findIndex(productValue => product.product_uid === productValue.product_uid);
    const value: any = this.lineItemFormGroup?.get(['tableRows', rowIndex, 'location'])?.value;
    return value ? value : '';
  }

  isSelectedProduct(product: any): boolean {
    if (this.selectedProducts?.length) {
      const matchedProduct = this.selectedProducts?.find(value => value.product_uid === product.product_uid && value?.line_item_uid === product?.line_item_uid);
      if(this.options?.module === 'JOB'){
        const matchedProducts = this.selectedProducts?.filter(value => value.product_uid === product.product_uid && value?.line_item_uid === product?.line_item_uid);
        if(matchedProducts?.length > 1){
          const actualProduct = matchedProducts.filter(prod => prod?.product_uid === product.product_uid && prod?.line_item_uid === product?.line_item_uid);
          return actualProduct.length ? true : false;
        }else{
          const isMatched = matchedProduct?.product_uid === product.product_uid && matchedProduct?.line_item_uid === product?.line_item_uid;
          return isMatched ?? false;
        }
      }else{
        return matchedProduct ? true : false;
      }
    }
    return false;
  }

  getSelectedProductWithModel(product: any): any {
    const matchedProduct = this.selectedProducts?.find(value => value.product_uid === product.product_uid);
    if(this.options?.module === 'JOB'){
      const matchedProducts = this.selectedProducts?.filter(value => value.product_uid === product.product_uid);
      const hasCloneProducts = matchedProducts?.length > 1;
      if(hasCloneProducts){
        const actualProduct = matchedProducts.filter(prod => prod?.price === product?.price && (prod?.available_quantity === product?.available_quantity || prod?.quantity === product?.quantity) && prod?.line_item_uid === product?.line_item_uid)[0];
        return actualProduct;
      }else{
        return matchedProduct;
      }
    }else{
      return matchedProduct ;
    }
  }

  validateProductValues(event: any, product: any, index: number): void {
    this.lineItemFormGroup.markAsUntouched();
    const control: any = this.lineItemFormGroup?.get(['tableRows', index]);
    if (control) {
      Object.keys(control?.controls).forEach((controlName: string) => {
        if(control?.controls[controlName]?.disabled){
          if(!['price', 'purchase_price'].includes(controlName) || !this.isEditSellingPriceDisabled){
            control?.controls[controlName]?.enable();
          }
        }
        if(controlName === 'quantity') {
          const mockProduct = _.cloneDeep(product);
          if(!control?.controls[controlName].value){
            product.mockQuantity = mockProduct?.quantity;
            product.quantity = 1;
            control?.controls[controlName]?.setValue(1);
            const validators = [this.utilityService.numberMinValueValidator];
            const requiredColumns: any[] = this.options.columns?.filter(column => column?.isEditable);
            const columnInfo = requiredColumns?.find((element: any)=> element?.type === 'QUANTITY');
            if (columnInfo.isRequired) {
              validators.push(Validators.required);
            }
            if(this.options?.data?.length > 0 && this.options?.showMaxQuantityError && product?.mockQuantity){
              validators.push(Validators.max(mockProduct?.quantity));
            }
            control?.controls[controlName]?.setValidators(validators);
            control?.controls[controlName]?.updateValueAndValidity();
          }else{
            product.mockQuantity = mockProduct?.quantity;
            product.quantity = null;
            control?.controls[controlName]?.setValue(null);
          }
        }
        if(controlName === 'serialNumber' && control?.controls[controlName].value?.length){
          control?.controls[controlName]?.setValue(null);
        }
      });
    }
  }

  disableProductRow(product: any, index: number): void{
    let rowIndex: number;
    if(this.options?.module === 'JOB' && index){
      rowIndex = index;
    }else{
      rowIndex = this.products.findIndex(productValue => product.product_uid === productValue.product_uid);
    }
    this.disableProductControl.forEach((item)=>{
      this.lineItemFormGroup?.get(['tableRows', rowIndex, item])?.disable();
    });
  }

  checkMarkupStatus(product: any): void{
    const rowIndex: number = this.products.findIndex(productValue => product.product_uid === productValue.product_uid);
    const isSellingPriceDisabled = product?.purchase_price && product?.markup?.markup_value;
    if(isSellingPriceDisabled){
      this.lineItemFormGroup?.get(['tableRows', rowIndex, 'price'])?.disable();
    }
  }

  handleInputSubscription(product, index: number): void{
    const selectedProduct: any = this.getSelectedProductWithModel(product);
    if(selectedProduct){
      if(this.utilityService.isEmptyOrUndefined(selectedProduct?.markup)){
        selectedProduct['markup'] = {
          markup_type: 'FLAT'
        };
      }
    }
    const isSelectedProduct = this.isSelectedProduct(product);
    const rowIndex: number = index;
    const subcriptionKey = product.product_uid;
    if(isSelectedProduct){
      const priceFormcontrol: AbstractControl = this.lineItemFormGroup?.get(['tableRows', rowIndex, 'price']);
      const markupFormControl: AbstractControl = this.lineItemFormGroup?.get(['tableRows', rowIndex, 'markup_value']);
      const purchasePriceFormControl: AbstractControl = this.lineItemFormGroup?.get(['tableRows', rowIndex, 'purchase_price']);
      if(markupFormControl){
        const markupSubscription = markupFormControl?.valueChanges.pipe(debounceTime(300),distinctUntilChanged()).subscribe((response)=>{
          if(response >= 0 && response !== null){
            selectedProduct.markup['markup_value'] = response;
            priceFormcontrol.disable();
            if(!this.utilityService.isEmptyOrUndefined(selectedProduct.markup['markup_value'])){
              this.updateSellingPrice(selectedProduct, rowIndex);
            }
          }else{
            selectedProduct.markup['markup_value'] = null;
            if(!this.isEditSellingPriceDisabled){
              priceFormcontrol.enable();
            }
            this.updateSellingPrice(selectedProduct, rowIndex);
          }
        });
        this.markupSubList[subcriptionKey] = markupSubscription;
      }
      if(purchasePriceFormControl){
        if(this.utilityService.isEmptyOrUndefined(purchasePriceFormControl.value) && priceFormcontrol.value){
          purchasePriceFormControl.setValue(priceFormcontrol.value);
          selectedProduct['purchase_price'] = priceFormcontrol.value;
          selectedProduct['unit_price_premarkup'] = priceFormcontrol.value;
        }
        const purchasePriceSubscription = purchasePriceFormControl.valueChanges.pipe(debounceTime(300),distinctUntilChanged()).subscribe((response)=>{
          if(response >= 0){
            selectedProduct['purchase_price'] = response;
            markupFormControl?.enable({emitEvent: false});
            if(!this.utilityService.isEmptyOrUndefined(selectedProduct.markup['markup_value'])){
              this.updateSellingPrice(selectedProduct, rowIndex);
            }
          }else{
            selectedProduct.markup['markup_value'] = null;
            selectedProduct.markup['markup_type'] = 'FLAT';
            selectedProduct.purchase_price = null;
            markupFormControl?.setValue(null);
            markupFormControl?.disable();
          }
        });
        this.purchasePriceSubList[subcriptionKey] = purchasePriceSubscription;
      }
      if(priceFormcontrol){
       priceFormcontrol.valueChanges.pipe(debounceTime(300),distinctUntilChanged()).subscribe((response)=>{
        const isCurrentlySelectedProduct = this.isSelectedProduct(product);
        this.updateSelectedProductFormControls(rowIndex, product?.product_uid, 'UPDATE');
        selectedProduct['price'] = response;
        if((response >= 0 || response === null) && !this.utilityService.isEmptyOrUndefined(selectedProduct.purchase_price) && isCurrentlySelectedProduct){
            markupFormControl?.enable({emitEvent: false});
          }
        });
      }
    }
  }
  selectProduct(event: any, product: any, index?: number): void {
    let rowIndex: number;
    if(this.options?.module === 'JOB'){
      rowIndex = index;
    }else{
      rowIndex = this.products.findIndex(productValue => product.product_uid === productValue.product_uid);
    }
    if (!event?.target?.closest('.mat-mdc-form-field-flex')) {
      product = { ...product };
      if (this.options.multipleLineItems) {
        if (event?.target?.checked) {
          const productLocation: any = this.getProductLocation(product);
          product['location_uid'] = productLocation ? productLocation : '';
          if(this.lineItemFormGroup?.get(['tableRows',rowIndex,'serialNumber'])){
            const serialNumber = this.lineItemFormGroup?.get(['tableRows',rowIndex,'serialNumber'])?.value;
            product['serial_nos'] = serialNumber? typeof serialNumber === 'string' ? [serialNumber] : serialNumber?.map((value: any) => value) : [];
          }
          this.selectedProducts.push(product);
          if(this.isColumnAvailable(this.options?.columns, LineItemPickerColumnType.MARKUP)){
            this.checkMarkupStatus(product);
          }
          if(this.filterLocationUid){
            this.lineItemFormGroup?.get(['tableRows', rowIndex, 'location'])?.disable();
          }else{
            this.lineItemFormGroup?.get(['tableRows', rowIndex, 'location'])?.enable();
          }
          this.updateQuantityControl(rowIndex, product, productLocation);
          this.updateSelectedProductFormControls(rowIndex, product?.product_uid, 'ADD');
        } else {
          const unMatchedProducts = this.selectedProducts.filter(value => ((value.product_uid !== product.product_uid) || (value?.line_item_uid !== product?.line_item_uid)));
          if(this.options?.module === 'JOB'){
            const matchedProducts = this.selectedProducts.filter(value => value.product_uid === product.product_uid && value?.line_item_uid === product?.line_item_uid);
            if(matchedProducts?.length > 1){
              const actualProducts = matchedProducts.filter(prod => prod?.line_item_uid !== product?.line_item_uid);
              this.selectedProducts = actualProducts;
            }else{
              this.selectedProducts = unMatchedProducts;
            }
          }else{
            this.selectedProducts = unMatchedProducts;
          }
          if(this.markupSubList[product.product_uid]){
            this.markupSubList[product.product_uid].unsubscribe();
            delete this.markupSubList[product.product_uid];
          }
          if(this.purchasePriceSubList[product.product_uid]){
            this.purchasePriceSubList[product.product_uid].unsubscribe();
            delete this.purchasePriceSubList[product.product_uid];
          }
          this.updateSelectedProductFormControls(rowIndex, product?.product_uid, 'DELETE');
          this.disableProductRow(product, rowIndex);
        }
        this.handleInputSubscription(product, rowIndex);
      } else {
        const productLocation: any = this.getProductLocation(product);
        const serialNumber= this.lineItemFormGroup?.get(['tableRows',rowIndex,'serialNumber'])?.value;
        product['location_uid'] = productLocation ? productLocation : '';
        product['serial_nos'] =serialNumber ?  typeof serialNumber === 'string' ? [serialNumber] : serialNumber?.map((value: any) => value) : [];
        this.selectedProducts = [product];
        if (this.options?.pickerType === 'popup') {
          this.zuperPopupService.closePopupSubject.next(this.selectedProducts);
        }
      }
    }
  }

  updateSelectedProductFormControls(rowIndex, productUid, action: 'ADD'|'UPDATE'|'DELETE'): void{
    const itemRowControl: AbstractControl = this.lineItemFormGroup?.get(['tableRows', rowIndex]);
    switch(action){
      case 'ADD':
        if(!this.selectedProductFormControl[productUid]){
          this.selectedProductFormControl[productUid] = itemRowControl;
        }
        break;
      case 'UPDATE':
        if(this.selectedProductFormControl[productUid]){
          this.selectedProductFormControl[productUid] = itemRowControl;
        }
        break;
      case 'DELETE':
        if(this.selectedProductFormControl[productUid]){
          delete this.selectedProductFormControl[productUid];
        }
        break;
      default:
        break;
    }
  }

  triggerSearch(searchKey: any): void {
    if (this.options?.data) {
      let filteredCategory: any[] = [];
      if (searchKey) {
        this.originalDataProducts.filter((value: any) => {
          if ((value?.product_name?.toLowerCase().includes(searchKey.toLowerCase())) || (value?.product_id?.toLowerCase().includes(searchKey.toLowerCase()))) {
            filteredCategory.push(value);
          }
        });
      } else {
        filteredCategory = this.originalDataProducts;
      }
      this.updateProducts(filteredCategory);
    } else {
      this.productParamObj['filter.keyword'] = searchKey;
      this.pagination.pageIndex = 1;
      this.getProductData();
    }
  }

  onPageItemEvent(event: any): void {
    this.pagination.pageIndex = event.pageIndex + 1;
    this.getProductData();
  }

  onProductLocationChange(event: any, product: any, index: number): void {
    const locationUID: string = event?.value ?? '';
    this.updateQuantityControl(index, product, locationUID);
    this.updateSelectedProductFormControls(index, product?.product_uid, 'UPDATE');
    const selectedProduct: any = this.getSelectedProductWithModel(product);
    if (selectedProduct) {
      selectedProduct['location_uid'] = locationUID;
    }
    const serialNumber: AbstractControl = this.lineItemFormGroup?.get(['tableRows', index, 'serialNumber']);
    serialNumber?.setValue([]);
  }

  updateQuantityControl(index, product, locationUID): void{
    let locationObject;
    if(product?.location_availability?.length){
      locationObject = product?.location_availability.find(locationItem => locationItem?.location?.location_uid === locationUID);
    }
    const quantityControl = this.lineItemFormGroup?.get(['tableRows', index,'quantity']);
    if(quantityControl){
      const isNotServiceType = product?.product_type !== 'SERVICE';
      if(locationObject?.quantity <= 0 && !this.addOutOfStockProduct && !this.addNegativeStockBalance){
        quantityControl.setValue(0);
        quantityControl.markAsDirty();
        quantityControl.markAllAsTouched();
        quantityControl.setValidators(this.ValidateQuantity());
        quantityControl.updateValueAndValidity();
      }else{
        const validators = [this.greaterThanZeroValidator(0)];
        this.options.columns?.filter(column => column?.isEditable).forEach((columnInfo)=>{
          if(columnInfo.type === 'QUANTITY'){
            if (columnInfo.isRequired) {
              validators.push(Validators.required);
            }
          }
        });
        quantityControl.setValue(1);
        quantityControl.markAsUntouched();

        const hasPredinedProducts = this.options?.data?.length > 0;
        const hasLocationFilter = this.products?.length && this.filterLocationUid;
        const hasLineItemLevelLocation = locationUID && !this.filterLocationUid;

        if((hasPredinedProducts || hasLocationFilter || hasLineItemLevelLocation) && this.options?.showMaxQuantityError && locationObject?.quantity && isNotServiceType && !this.addNegativeStockBalance){

          validators.push(Validators.max(locationObject?.quantity));
        }
        quantityControl.setValidators(validators);
        quantityControl.updateValueAndValidity();
      }
    }
  }

  getLineItemModel(product: any): any {
    return this.createLineItemModel(product);
  }

  validateSelectedItemsControls(): boolean {
    this.lineItemFormGroup.markAsUntouched();
    let isValid: boolean = true;
    if((this.options?.multipleLineItems === true) && (this.options?.addFromProductGroup === false)){
      for (const control in this.selectedProductFormControl) {
        if(this.selectedProductFormControl[control]?.status === 'INVALID'){
          isValid = false;
        }
      }
    }else{
        this.selectedProducts.forEach((product: any) => {
          const rowIndex: number = this.products.findIndex(productValue => product.product_uid === productValue.product_uid);
          if (rowIndex > -1) {
            const itemRowControl: AbstractControl = this.lineItemFormGroup?.get(['tableRows', rowIndex]);
            itemRowControl?.markAllAsTouched();
            if (itemRowControl?.valid === false) {
              isValid = false;
            }
          }
        });
    }
    return isValid;
  }

  ValidateQuantity(): ValidatorFn | null  {
    return (): ValidationErrors | null => ({'OutOfStock': true });
  };

  addLineItems(): void {
    if (this.validateSelectedItemsControls()) {
      const selectedProducts: any[] = [];
      this.selectedProducts.forEach((product: any) => {
        selectedProducts.push(this.getLineItemModel(product));
      });
      this.lineItemPickerService.onAddItemClicked.next(selectedProducts);
    }
  }

  addItems(_event: any): void {
    if (this.viewMode === 'SingleItem') {
      this.addLineItems();
    } else if (this.viewMode === 'ItemGroup') {
      this.addGroupItems();
    }
  }

  addGroupItems(): void {
    if (this.selectedGroupProducts.length) {
      this.selectedGroupProducts.forEach((value: any) => {
        this.groupAddingObj[value['product_group_uid']] = true;
      });
      this.selectedGroupProducts.forEach((value: any) => {
        this.getProductGroupDetails(value['product_group_uid']);
      });
    } else {
      if (this.options?.pickerType === 'popup') {
        this.zuperPopupService.closePopupSubject.next([]);
      } else {
        this.lineItemPickerService.onAddItemClicked.next(this.selectedProducts);
      }
    }
  }

  disableAddButton(): boolean {
    if (this.viewMode === 'SingleItem') {
      return !this.selectedProducts.length && !this.options.multipleLineItems;
    } else if (this.viewMode === 'ItemGroup') {
      return this.isAddItemLoading || (!this.selectedGroupProducts.length && !this.options.multipleLineItems);
    }
    return false;
  }

  hideSelectedItemsPanel(): void {
    if (this.viewMode === 'SingleItem') {
      this.updateProducts(this.originalDataProducts);
    } else if (this.viewMode === 'ItemGroup') {
      this.groups = this.originalDataGroups;
    }
    this.showSelectedItems = false;
  }

  showSelectedItemsPanel(): void {
    if (this.viewMode === 'SingleItem') {
      this.updateProducts(this.selectedProducts);
    } else if (this.viewMode === 'ItemGroup') {
      this.groups = this.selectedGroupProducts;
    }
    this.showSelectedItems = true;
  }

  checkPanelVisibility(): boolean {
    if (this.viewMode === 'SingleItem') {
      return this.selectedProducts.length > 0;
    } else if (this.viewMode === 'ItemGroup') {
      return this.selectedGroupProducts.length > 0;
    }
    return false;
  }

  getBadgeOptions(): BadgeOptions {
    return {
      type: 'PRIMARY',
      displayKey: null,
      displayName: this.getSelectedItemsCount(),
      displayType: 'listingCount'
    };
  }

  getSelectedItemsCount(): number {
    let count: number = 0;
    if (this.viewMode === 'SingleItem') {
      count = this.selectedProducts.length;
    } else if (this.viewMode === 'ItemGroup') {
      count = this.selectedGroupProducts.length;
    }
    return count;
  }

  // getProductsReference(data: any): any[] {
  //   const products: any[] = [];
  //   data.forEach((product: any) => {
  //     if (product['product_ref_id']) {
  //       products.push(product['product_ref_id']);
  //     }
  //   });
  //   return products;
  // }

  //Selection Change Events - Filters
  onProductTypeChange(event: any): void {
    if (event) {
      const type: lineItemType | '' = event.value;
      if (this.options?.data) {
        let filteredProducts: any[] = [];
        if (type) {
          filteredProducts = this.originalDataProducts.filter(value => ((value.product_type === type) || (value?.product_ref_id?.product_type === type))) ?? [];
        } else {
          filteredProducts = this.originalDataProducts;
        }
        this.updateProducts(filteredProducts);
      } else {
        this.pagination.pageIndex = 1;
        if(type === ''){
          this.setProductTypeFilter();
        }else{
          this.productParamObj['filter.product_type'] = type;
        }
        this.getProductData();
      }
    }
  }

  onAvailabilityChange(event: any): void {
    if (event) {
      const type: any = event.value;
      if (this.options?.data) {
        let filteredProducts: any[] = [];
        if (type !== 'ALL') {
          filteredProducts = this.originalDataProducts.filter(value => value.is_available === type) ?? [];
        } else {
          filteredProducts = this.originalDataProducts;
        }
        this.updateProducts(filteredProducts);
      } else {
        this.pagination.pageIndex = 1;
        if (type === 'ALL') {
          delete this.productParamObj['filter.is_available'];
        } else {
          this.productParamObj['filter.is_available'] = type;
        }
        this.getProductData();
      }
    }
  }

  onCategoryChange(event: any): void {
    if (event) {
      const categoryId: any = event.value;
      if (this.options?.data) {
        let filteredCategory: any[] = [];
        if (categoryId) {
          this.originalDataProducts.filter((value: any) => {
            if (((value.product_category?.category_uid === categoryId) || (value?.product_ref_id?.product_category?.category_uid === categoryId))) {
              filteredCategory.push(value);
            }
          });
        } else {
          filteredCategory = this.originalDataProducts;
        }
        this.updateProducts(filteredCategory);
      } else {
        this.pagination.pageIndex = 1;
        this.productParamObj['filter.product_category'] = categoryId;
        this.getProductData();
      }
    }
  }

  onLocationChange(event: any): void {
    if (event) {
      if (this.options?.data) {
        const locationId: any = event?.value;
        let filteredData: any[] = [];
        if (locationId) {
          filteredData = this.originalDataProducts.filter((value: any) => {
            return (value?.location_uid === locationId) || (value?.location?.location_uid === locationId);
          });
        } else {
          filteredData = this.originalDataProducts;
        }
        this.updateProducts(filteredData);
      }else{
        this.pagination.pageIndex = 1;
        this.productParamObj['filter.location'] = this.selectedLocationValue !== 'ALL' ? this.selectedLocationValue : '';
        this.filterLocationUid = event?.location_uid;
        if (event?.location_uid === 'ALL') {
          setTimeout(() => {
            this.selectedLocationValue = null;
            this.filterLocationUid = null;
          });
        }
        this.getProductData();
      }
    }
  }

  createLineItemModel(product: any): LineItemModel {
    const unitPrice: number = !this.utilityService.isEmptyOrUndefined(product['price'] ?? product['unit_price']) ? (product['price'] ?? product['unit_price']) : 0;
    const quantity: number = !this.utilityService.isEmptyOrUndefined(product['quantity']) ? product['quantity'] : 0;
    const itemModel: LineItemModel = {
      'product_category': this.getCategoryAsObject ? (product?.product_category ?? '') : (product?.product_category?.category_uid ?? ''),
      'product_description': product['product_description'] ?? '',
      'product_name': product['name'] ?? product['product_name'],
      'product_image': product['product_image'] ?? null,
      'product_id': product['product_id'],
      'product_type': product['product_type'] ?? null,
      'product_uid': product['product_uid'],
      'quantity': quantity,
      'price': unitPrice,
      'meta': product?.meta_data ?? [],
      'location_uid': ((product?.['product_type'] && product?.['product_type'] !== 'SERVICE') || (product?.['product_ref_id']?.['product_type'] && product?.['product_ref_id']?.['product_type'] !== 'SERVICE')) ? (product?.location_uid ?? '') : '',
      'purchase_price': product['purchase_price']
    };
    itemModel['name'] = product['name'] ?? product['product_name'];
    itemModel['unit_price'] = unitPrice;
    if (product['description']) {
      itemModel['description'] = product['description'];
    }
    if (product['specification']) {
      itemModel['specification'] = product['specification'];
    }
    if (product['brand']) {
      itemModel['brand'] = product['brand'];
    }
    if (product['prefix']) {
      itemModel['prefix'] = product['prefix'];
    }
    if (product['uom']) {
      itemModel['uom'] = product['uom'];
    }
    if (product?.['tax']){
      itemModel['tax'] = product?.tax;
    }
    if (product?.['location_availability']){
      itemModel['product_ref_id'] = {
        location_availability: product?.['location_availability'],
      };
    }
    if(product?.['product_ref_id']){
      itemModel['product_ref_id'] = product?.['product_ref_id'];
    }
    if (product?.['serial_nos']){
      itemModel['serial_nos'] = product?.serial_nos;
    }
    if(product?.group_uid || product?.product_group_uid){
      itemModel['group_uid'] = product?.group_uid ||  product?.product_group_uid;
    }

    if(product?.group_name || product?.product_group_name){
      itemModel['group_name'] = product?.group_name || product?.product_group_name;
    }

    if(product?.location_uid && product?.location_availability?.length){
      const locationArray = product.location_availability.filter(locationDetails =>  locationDetails?.location?.location_uid === product?.location_uid);
      itemModel['location_name'] = locationArray.length ? locationArray[0].location?.location_name : '';
    }
    if(product['markup'] && product['markup'].markup_value){
      itemModel['markup'] = product.markup;
    }
    if(product['unit_price_premarkup']){
      itemModel['unit_price_premarkup'] = product.unit_price_premarkup;
    }else if(product['markup'] && product['markup'].markup_value && (product['purchase_price'] || product['unit_price'])){
      itemModel['unit_price_premarkup'] = product['purchase_price'] ?? product['unit_price'];
    }
    if(product['available_quantity']){
      itemModel['available_quantity'] = product.available_quantity;
    }
    if(product['line_item_uid']){
      itemModel['line_item_uid'] = product?.line_item_uid;
    }
    if(product['pricing_level']){
      itemModel['pricing_level'] = product?.pricing_level;
    }
    const isBillable = product['is_billable'] ?? true;
    itemModel['is_billable'] = isBillable;

    if (product['associated_products']?.length > 0) {
      itemModel['associated_products'] = [];
      product.associated_products.forEach((oneProduct: any) => {
        if (oneProduct?.product) {
          const lineItem: any = { ...oneProduct.product, ...oneProduct };
          // delete lineItem.product;
          itemModel['associated_products'].push(lineItem);
        }
      });
    }

    return itemModel;
  }

  getProductSerialNumbers(product: any,index): any {
    let serialNumbers: string[] = [];
    if (product) {
      const rowIndex: number = index;
      const selectedLocation = this.lineItemFormGroup.get(['tableRows', rowIndex, 'location'])?.value;
      const filteredLocation = this.options?.remoteData?.params?.['filter.location'];
      const cumulativeSerialNumbers: any[] = [...new Set(_.flatMap(product?.location_availability?.map((data: any)=>data?.serial_nos)))];
      if(product?.serial_nos){
        serialNumbers = product.serial_nos;
      }else if (!this.utilityService.isEmptyOrUndefined(cumulativeSerialNumbers) && (selectedLocation !== '' && this.utilityService.isEmptyOrUndefined(selectedLocation))) {
        serialNumbers = cumulativeSerialNumbers;
      } else if (selectedLocation && product?.location_availability) {
        product.location_availability?.forEach((location: any) => {
          if (location?.location?.location_uid === selectedLocation) {
            serialNumbers = serialNumbers.concat(location?.serial_nos ?? []);
          }
        });
      }else if (filteredLocation && product?.location_availability) {
        product.location_availability?.forEach((location: any) => {
          if (location?.location?.location_uid === filteredLocation) {
            serialNumbers = serialNumbers.concat(location?.serial_nos ?? []);
          }
        });
      }
    }
    return serialNumbers;
  }

  isLineItemAvailable(item: any): boolean {
    if (!this.utilityService.isEmptyOrUndefined(item.is_available)) {
      return item.is_available;
    } else if (!this.utilityService.isEmptyOrUndefined(item?.product_ref_id?.is_available)) {
      return item?.product_ref_id?.is_available;
    }
    return false;
  }

  //Line item form control methods
  hasInvalidValue(index: number, controlName: string, product: any): boolean {
    const control = this.lineItemFormGroup?.get(['tableRows', index, controlName]);
    return control?.touched && !control?.valid;
  }

  getControlValue(index: number, controlName: string): any {
    const control = this.lineItemFormGroup?.get(['tableRows', index, controlName]);
    return control?.value ?? '';
  }

  allowToAddOutOfStockProduct(product: any, index: number): boolean {
    if(this.options?.enableOutOfStockProduct){
      return !this.options.enableOutOfStockProduct;
    }else{
      return this.showOutOfStockAlert(product, index) && !this.addOutOfStockProduct ;
    }
  }

  showOutOfStockAlert(product: any, index: number): boolean {
    if(product?.product_type !== 'SERVICE'){
      if (!this.isSelectedProduct(product) && !this.hasInvalidValue(index, 'quantity', product)) {
        if (product?.location_availability?.length > 0) {
          const productWithQuantity =  product?.location_availability?.filter(element => element?.quantity > 0);
          return productWithQuantity?.length > 0 ? false: true;
        }else{
          if(this.options?.enableOutOfStockProduct){
            return !this.options.enableOutOfStockProduct;
          }else{
            return product?.quantity <= 0;
          }
        }
      }else if(this.isSelectedProduct(product)){
        const matchedLocation = product?.location_availability?.find(locationItem => locationItem?.location?.location_uid === product?.location_uid);
        return matchedLocation?.quantity <= 0;
      }
    }
    return false;
  }

  onSerialNoBlur(event: any): void {
    if (event?.target) {
      event.target.value = '';
    }
  }

  trackByValue(_index: number, item: any): any {
    return item.label ? item.label : item;
  }

  setErrorsSerialNumberControl(quantity: number, index: number): void {
    const serialNumber: AbstractControl = this.lineItemFormGroup?.get(['tableRows', index, 'serialNumber']);
    if (serialNumber) {
      const serialNumbers: any[] = serialNumber?.value;
      if (quantity > 0 && serialNumbers?.length > 0 && serialNumbers?.length !== quantity) {
        serialNumber?.setErrors({ mismatchCount: true });
      } else {
        serialNumber?.setErrors(null);
      }
    }
  }

  validateSerialNumberCount(index: number, multiple: boolean, controller: AbstractControl): any {
    const quantityCol: any = this.options?.columns.find(column => column.type === LineItemPickerColumnType.QUANTITY);
    const quantity: any = quantityCol ? Number(this.getControlValue(index, 'quantity')) : 1;
    const serialNumbers: string[] = multiple ? controller.value : (controller.value ? [controller.value] : []);
    if (quantity > 0 && serialNumbers?.length > 0 && serialNumbers?.length !== quantity) {
      return {
        mismatchCount: true
      };
    }
    return null;
  }

  //Group item
  getGroupData(): void {
    this.loaded = false;
    this.groupParamObj.page = this.groupPagination.pageIndex;
    this.dataCollectorService.getData(this.lineItemApiUrls.productGroupUrl, this.groupParamObj).subscribe((response: any) => {
      this.loaded = true;
      this.groups = response.data;
      this.originalDataGroups = response.data;
      this.groupPagination.totalRecords = response.total_records;
    }, (_error: any) => {
      this.loaded = true;
    });
  }

  getGroupStatusBadgeOptions(isAvailable: boolean): BadgeOptions {
    return {
      displayKey: isAvailable ? 'active.text' : 'text.inactive',
      displayName: isAvailable ? 'Active' : 'Inactive',
      type: isAvailable ? 'ACTIVE' : 'INACTIVE'
    };
  }

  triggerGroupSearch(searchKey: any): void {
    this.groupPagination.pageIndex = 1;
    this.groupParamObj['filter.keyword'] = searchKey;
    this.getGroupData();
  }

  onPageGroupEvent(event: any): void {
    this.groupPagination.pageIndex = event.pageIndex + 1;
    this.getGroupData();
  }

  isSelectedGroup(product: any): boolean {
    if (this.selectedGroupProducts?.length) {
      return this.selectedGroupProducts.find(value => value.product_group_uid === product.product_group_uid) ? true : false;
    }
    return false;
  }

  selectGroup(event: any, productGroup: any): void {
    if (this.options.multipleLineItems) {
      if (event?.target?.checked) {
        this.selectedGroupProducts.push(productGroup);
      } else {
        const removeProducts = this.masterGroupItems[productGroup.product_group_uid]?.associated_products;
        if(removeProducts?.length) {
          removeProducts.forEach((element: any)=>{
            if(this.selectProductObj[element?.product.product_uid] && (this.selectProductObj[element?.product?.product_uid]?.quantity > element?.quantity)){
              this.selectProductObj[element?.product?.product_uid] = {...this.selectProductObj[element?.product?.product_uid],quantity: (this.selectProductObj[element?.product?.product_uid]?.quantity - (element?.quantity))};
              delete this.selectProductObj[element?.product?.product_uid]['group'];
              delete this.selectProductObj[element?.product?.product_uid]['group_uid'];
              this.selectedProducts = this.selectedProducts.map((data: any)=>this.selectProductObj[data?.product_uid]);
            }else{
              delete this.selectProductObj[element?.product?.product_uid];
              this.selectedProducts = this.selectedProducts.filter((data: any)=> data?.product_uid !== element?.product?.product_uid);
            }
          });
        }
        this.selectedGroupProducts = this.selectedGroupProducts.filter(value => value.product_group_uid !== productGroup.product_group_uid);
      }
    } else {
      this.selectedGroupProducts = [productGroup];
      if (this.options?.pickerType === 'popup') {
        this.addGroupItems();
      }
    }
  }

  getIndividualGroupDetails(productGroupUID: string): void {
    this.dataCollectorService.getData(this.lineItemService.getProductGroupDetails(productGroupUID)).subscribe((response: any) => {
      this.masterGroupItems[productGroupUID] = response?.data;
    }, (_error: any) => {
    });
  }

  getProductGroupDetails(productGroupUID: string): void {
    this.isAddItemLoading = true;
    let urlParams: any;
    if(this.options?.remoteData?.params){
      urlParams = this.utilityService.constructParam(this.options.remoteData.params);
    }
    this.dataCollectorService.getData(this.lineItemService.getProductGroupDetails(productGroupUID), urlParams).subscribe((response: any) => {
      this.formattedGroupItems.push(response.data);
      delete this.groupAddingObj[productGroupUID];
      if (!Object.keys(this.groupAddingObj).length) {
        this.isAddItemLoading = false;
        this.createGroupItemsModel();
      }
    }, (_error: any) => {
      this.isAddItemLoading = false;
      delete this.groupAddingObj[productGroupUID];
    });
  }

  createGroupLineItemModel(product: any): GroupLineItemModel {
    let lineItemModel: GroupLineItemModel = {
      group_uid: product.group_uid,
      meta: [],
      price: product.price ?? product.unit_price,
      unit_price: product.unit_price ?? product.price,
      product_category: product?.product_category?.category_uid ?? '',
      product_description: product.product_description ?? '',
      product_id: product.product_id ?? '',
      product_manual_link: product.product_manual_link ?? '',
      product_name: product.product_name ?? '',
      product_type: product.product_type ?? '',
      product_uid: product.product_uid ?? '',
      quantity: product.quantity ?? 0
    };
    if(product.tax && Object.keys(product.tax).length > 0){
      lineItemModel = {...lineItemModel,tax: product.tax};
    }
    return lineItemModel;
  }

  createGroupItemsModel(): void {
    const lineItems: any[] = [];
    this.formattedGroupItems.forEach((value: any) => {
      const associatedProducts: any[] = value?.associated_products ?? [];
      associatedProducts.forEach((product: any) => {
        if (product.product) {
          const lineItem: any = { 'group_name': value['product_group_name'], 'group_uid': value['product_group_uid'], ...product.product, ...product };
          delete lineItem.product;
          lineItems.push(this.createLineItemModel(lineItem));
        }
      });
    });
    if (this.options?.pickerType === 'popup') {
      this.zuperPopupService.closePopupSubject.next(lineItems);
    } else {
      const resultLineItem = [];
      const resultObj = {};
      lineItems.forEach((element: any)=>{
        let updatedProduct: any = element;
        if(this.selectProductObj[element?.product_uid] && !this.selectProductObj[element?.product_uid]?.group_uid){
          this.selectProductObj[element?.product_uid] = {...element,...this.selectProductObj[element?.product_uid],quantity: this.selectProductObj[element?.product_uid]?.quantity + element?.quantity};
          updatedProduct = this.selectProductObj[element?.product_uid];
        }else if(this.selectProductObj[element?.product_uid] && this.selectProductObj[element?.product_uid]?.group_uid){
          updatedProduct = this.selectProductObj[element?.product_uid];
        }
        resultLineItem.push(updatedProduct);
        resultObj[element?.product_uid] = updatedProduct;
      });

      this.selectedProducts.forEach((element: any, i: number)=>{
        if(!resultObj[element?.product_uid])
        {
          resultLineItem.push(this.selectProductObj[element?.product_uid]);
          resultObj[element?.product_uid] = this.selectProductObj[element?.product_uid];
        }

        this.selectedProducts[i] = resultObj[element?.product_uid];
      });

      let finalArrayOfProducts = [];
      const ids = this.selectedProducts.map((data: any)=> data?.product_uid);
      finalArrayOfProducts = [...this.selectedProducts,...resultLineItem.filter((data: any)=>!ids.includes(data?.product_uid))];

      this.lineItemPickerService.onAddItemClicked.next(finalArrayOfProducts);
    }
  }

  hasSameLineItem(product: any, lineItems: any[]): boolean {
    let itemIndex: number = -1;
    lineItems.forEach((item: any, index: number) => {
      if (item['product_uid'] === product['product_uid']) {
        itemIndex = index;
      }
    });
    if (itemIndex > -1 && lineItems[itemIndex]) {
      lineItems[itemIndex].quantity = (lineItems[itemIndex].quantity + product.quantity);
      lineItems[itemIndex].total = lineItems[itemIndex].unit_price * lineItems[itemIndex].quantity;
      return true;
    }
    return false;
  }

  validateGroupItems(data: any[]): void {
    this.selectedGroupProducts = [];
    if (data?.length) {
      const groupUIDs: any = {};
      data.forEach((value: any) => {
        if (value?.group_uid && this.utilityService.isEmptyOrUndefined(groupUIDs[value.group_uid])) {
          groupUIDs[value.group_uid] = true;
        }
      });
      if (Object.keys(groupUIDs).length) {
        const groupParamObj: any = {
          'count': 50,
          'page': 1,
          'sort': 'ASC',
          'sort_by': 'created_at'
        };
        this.dataCollectorService.getData(this.lineItemApiUrls.productGroupUrl, groupParamObj).subscribe((response: any) => {
          if (response?.data) {
            const groups: any[] = response.data;
            groups.forEach((group: any) => {
              if (Object.keys(groupUIDs).length && !this.utilityService.isEmptyOrUndefined(groupUIDs[group['product_group_uid']])) {
                this.selectedGroupProducts.push(group);
                this.getIndividualGroupDetails(group['product_group_uid']);
                delete groupUIDs[group['product_group_uid']];
              } else if (!Object.keys(groupUIDs).length) {
                return;
              }
            });
          }
        }, (_error: any) => {
        });
      }
    }
  }

  changeMarkupType(element, type): void{
    this.markupEventAnalyticsService.trackEventAnalytics(this.options?.module);
    const selectedProduct: any = this.getSelectedProductWithModel(element);
    const rowIndex: number = this.products.findIndex(productValue => element.product_uid === productValue.product_uid);
    if (selectedProduct && selectedProduct?.markup) {
      selectedProduct.markup['markup_type'] = type;
      if(!this.utilityService.isEmptyOrUndefined(selectedProduct.markup['markup_value'])){
        this.updateSellingPrice(selectedProduct, rowIndex);
      }
    }
  }

  markupValueChange(event): void{
    this.markupEventAnalyticsService.trackEventAnalytics(this.options?.module);
  }

  getMarkupType(element): string{
    const selectedProduct: any = this.getSelectedProductWithModel(element);
    return selectedProduct?.markup?.markup_type ?? this.markupType;
  }

  updateSellingPrice(selectedProduct, rowIndex): void{
    const purchasePrice = selectedProduct?.purchase_price;
    const markupValue = selectedProduct?.markup?.markup_value;
    const markupType = selectedProduct?.markup?.markup_type;
    const priceFormcontrol = this.lineItemFormGroup?.get(['tableRows', rowIndex, 'price']);
    const markupFormControl = this.lineItemFormGroup?.get(['tableRows', rowIndex, 'markup_value']);
    if(markupValue >= 0 && markupValue !== null){
      let updatedSellingPrice: number = 0;
      switch (markupType) {
        case 'FLAT':
          updatedSellingPrice = purchasePrice + markupValue;
          break;
        case 'PERCENTAGE':
          updatedSellingPrice = purchasePrice + (purchasePrice * (markupValue/100));
          break;
        case 'MULTIPLIER':
          updatedSellingPrice = purchasePrice * markupValue;
          break;
        default:
          break;
      }
      if(updatedSellingPrice >= 0){
        const fixedDecimalSellingPrice = updatedSellingPrice.toFixed(this.currencyDecimal);
        priceFormcontrol.setValue(fixedDecimalSellingPrice);
        selectedProduct['price'] = fixedDecimalSellingPrice;
      }
    }else if(markupValue === 0){
      markupFormControl?.markAsTouched();
      priceFormcontrol.setValue(purchasePrice);
      selectedProduct['price'] = purchasePrice;
    }else if(purchasePrice){
      priceFormcontrol.setValue(purchasePrice);
      selectedProduct['price'] = purchasePrice;
    }
    if(purchasePrice >=0 && markupFormControl?.value >=0 && markupFormControl?.value !== null) {
          priceFormcontrol.disable();
    }else {
      if(!markupValue) {
        priceFormcontrol.enable();
      }else{
        priceFormcontrol.disable();
      }
    }
    priceFormcontrol.markAsUntouched();
    priceFormcontrol.updateValueAndValidity();
  }

  isColumnAvailable(array ,columnType): boolean{
    const matchedObject = array.find(column => column.type === columnType);
    if(matchedObject){
      return true;
    }else{
      return false;
    }
  }

  greaterThanZeroValidator(threshold: number, isSupportZero: boolean = false): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;
      const isValid = isSupportZero ? value >= threshold : value > threshold;
      if (value === null || value === undefined || value === '') {
        return null;
      }
      return isValid ? null : { 'min': true };
    };
  }

  // #region location filter
  getLocationDetails(): void{
    const getLocationDetail = `${this.lineItemApiUrls.productLocationUrl}/${this.defaultPreferredLocationUid}`
    this.dataCollectorService.getData(getLocationDetail).subscribe({
      next: (response)=>{
        if(response?.data){
          const locationDetails = response?.data;
          if(locationDetails?.is_deleted){
            this.getLineItemData();
            return;
          };
          const preferredLocationDetails = locationDetails;
          this.selectedLocationValue = this.defaultPreferredLocationUid;
          this.productParamObj['filter.location'] = this.defaultPreferredLocationUid;
          this.filterLocationUid = this.defaultPreferredLocationUid;
          this.getLineItemData(preferredLocationDetails);
        };
      },
      error: (err)=>{
        this.getLineItemData();
      }
    });
  };
  getProductLocationData(onInit: boolean = false, locationDetails?): Observable<any> {
    if (!this.options?.filters?.location?.enabled) {
      return of([]);
    }
    const params = { 'page': this.locationSearchPagination.currentPage, 'count': 10, 'sort': 'ASC', 'sort_by': 'location_name', 'filter.keyword': this.locationSearchPagination.keyword || ''};
    this.locationSearchPagination.isLoading = true;
    return this.dataCollectorService.getData(this.lineItemApiUrls.productLocationUrl, params)
      .pipe(
        map((response: any) => {
          const locationsArray = response?.data || [];
          if(locationDetails && !locationsArray?.some(location => location?.location_uid === locationDetails?.location_uid)){
            locationsArray.unshift(locationDetails);
          };
          const locationList = [this.allProductLocationSelectOption, ...locationsArray];
          if(onInit && locationList?.length <= 1) {
            this.selectedLocationValue = 'ALL';
          }
          this.locationSearchPagination.totalPage = response.total_pages || 1;
          this.locationSearchPagination.currentPage = Number(response.current_page) || 1;
          this.productLocationPickerList = _.unionBy([this.allProductLocationSelectOption], this.productLocationPickerList, locationsArray, 'location_uid');
          this.locationSearchPagination.isLoading = false;
          return locationList;
        }), 
        catchError((error: any) => {
          this.locationSearchPagination.isLoading = false;
          return of([]);
        })
    );
  }
  onLocationSearch(): void {
    this.locations = this.locationValueSubject.pipe(
      distinctUntilChanged(),
      debounceTime(400),
      switchMap((term: any) => {
        this.locationSearchPagination.keyword = term;
        this.locationSearchPagination.currentPage = 1;
        if(term === '') {
          this.productLocationPickerList = [];   
        }
        return this.getProductLocationData();
      })
    );
  }
  locationPickerScrollToEnd(): any {
    if (this.locationSearchPagination.currentPage < this.locationSearchPagination.totalPage) {
      this.locationSearchPagination.currentPage += 1;
      this.getProductLocationData().subscribe(() => {
        this.locations = of(_.uniqBy(this.productLocationPickerList, 'location_uid'));
      });

    }
  }
  trackByLocationUid(index: number, location: any): string {
    return location?.location_uid;
  }

  ngOnDestroy(): void {
    this.lineItemSubscription?.unsubscribe();
    this.patchFiltersFromSDKSub$?.unsubscribe();
  }

  // #REGION UI SDK
  initializeSDKHandlers(): void{
    this.utilityService.castModalEventToSdk('open', {
      id: 'line_item',
    });
    this.currentPage = this.utilityService.collectRouteData(this.route.snapshot)['page'];
    this.patchFiltersFromSDK();
  }

  emitEventToSDK(): void{
    const data = Object.assign({}, this.filterValues);
    this.filterValues['location'] = this.selectedLocationValue;
    if(this.selectedLocationValue){
      data['location'] = this.productLocationPickerList.find(location=> location.location_uid == this.selectedLocationValue) || this.selectedLocationValue
    }
    if(data['category']){
      data['category'] = this.categories.find(category=> category.category_uid == this.filterValues['category']) || null;
    }
    this.utilityService.castModalEventToSdk('change', {
      id: 'line_item',
      filter_values: data
    })
  }

  patchFiltersFromSDK(): void{
    this.patchFiltersFromSDKSub$ = this.utilityService.listenForFormPatchEvent(`${this.currentPage}.line_item`).pipe(
      tap((res: MetaData) => {
        const controlName = res.data['controlName'];
        if (!controlName) {
          return;
        }

        if (res.key.includes('set')) {
          const value = res.data['value'];

          const filterHandlers = {
            'product_type': this.onProductTypeChange,
            'category': this.onCategoryChange,
          };
          if(controlName === 'location'){
            this.filterValues['location'] = value;
            this.selectedLocationValue = value;
            this.onLocationChange({ location_uid: value ?? '' });
          }else if(filterHandlers[controlName]){
            filterHandlers[controlName]?.call(this, { value: value ?? '' });
            this.filterValues[controlName] = value;
          }
        }
      })
    ).subscribe();
  }
}
